// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 711) return "static/chunks/8e1d74a4-2bfc3006e0a57589.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"303":"d427be798902b614","329":"37b69817eb4d2b04","527":"bf70be91a2bf1e4b","919":"105d60c0c96f64b1"}[chunkId] + ".js";
};